export enum CollabGroupSortType {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
  MANUAL = 'manual'
}

export type CollabFieldGroupingJSON = {
  fieldId: string;
  sortType: CollabGroupSortType;
  manualGroupOrder: string[];
};

export type CollabGroupingJSON = {
  groupBy?: CollabFieldGroupingJSON;
  subgroupBy?: CollabFieldGroupingJSON;
};

export interface CollabFieldGrouping {
  get fieldId(): string;
  get sortType(): CollabGroupSortType;
  get manualGroupOrder(): string[];
  toJSON(): CollabFieldGroupingJSON;
}

export interface MutableCollabFieldGrouping extends CollabFieldGrouping {
  set fieldId(fieldId: string);
  set sortType(type: CollabGroupSortType);
  set manualGroupOrder(order: string[]);
  addGroupBefore(groupKey: string, beforeGroupKey: string): void;
}

export interface CollabGrouping {
  get groupBy(): MutableCollabFieldGrouping | undefined;
  get subgroupBy(): MutableCollabFieldGrouping | undefined;
  toJSON(): CollabGroupingJSON;
}

export interface MutableCollabGrouping extends CollabGrouping {
  groupByField(fieldId: string, manualGroupOrder?: string[]): MutableCollabFieldGrouping;
  setGroupBy(fieldGrouping: CollabFieldGroupingJSON): MutableCollabFieldGrouping;
  subgroupByField(
    fieldId: string,
    manualGroupOrder?: string[]
  ): MutableCollabFieldGrouping;
  setSubgroupBy(fieldGrouping: CollabFieldGroupingJSON): MutableCollabFieldGrouping;
  clear(): void;
  clearGroupBy(): void;
  clearSubgroupBy(): void;
}
